<template>
  <v-header></v-header>
  <div class="container-fluid" id="allProducts">
    <v-banner :show.sync="store.banner.Enabled" :banner="store.banner"></v-banner>
    <router-view></router-view>
  </div>
  <v-footer></v-footer>
</template>

<script>
import NavigationHeader from './components/navigation/NavigationHeader'
import Footer from './components/navigation/Footer'
import store from './store.js'
import banner from './components/Common/banner'

export default {
  replace: false,
  components: {
    'v-header': NavigationHeader,
    'v-footer': Footer,
    'v-banner': banner
  },
  data: function () {
    return {
      store: store
    }
  },
  created () {
    store.checkAuth()
    store.checkBanner()
    if (sessionStorage.getItem('winkelwagen')) {
      this.store.cart = JSON.parse(sessionStorage.getItem('winkelwagen'))
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// App.vue?96e0dc38